/* ============================================================
   KROQ — Comportements de marque globaux
   · Scroll-reveal pour [data-kroq-reveal] (IntersectionObserver)
   · Accordéons mutualisés [data-kroq-accordion] (un seul ouvert, fluide)
   Défensif, idempotent, dégrade proprement sans JS.
   ============================================================ */
(function () {
  'use strict';

  /* ── Scroll reveal ── */
  function initReveal() {
    var els = document.querySelectorAll('[data-kroq-reveal]:not([data-kroq-seen])');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { el.setAttribute('data-kroq-seen', '1'); io.observe(el); });
  }

  /* ── Accordéons (single-open, hauteur animée) ── */
  function initAccordions() {
    document.querySelectorAll('[data-kroq-accordion]:not([data-kroq-acc-init])').forEach(function (group) {
      group.setAttribute('data-kroq-acc-init', '1');
      var items = group.querySelectorAll('[data-kroq-acc-item]');
      items.forEach(function (item) {
        var head = item.querySelector('[data-kroq-acc-head]');
        if (!head) return;
        head.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          if (group.hasAttribute('data-kroq-single')) {
            items.forEach(function (other) { other.classList.remove('is-open'); });
          }
          item.classList.toggle('is-open', !isOpen);
        });
      });
    });
  }

  function boot() {
    initReveal();
    initAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
